import axios from 'axios';
import moment from 'moment-timezone';

function downloadResource(dataString, name) {
  const downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute('href', dataString);
  downloadAnchorNode.setAttribute('download', name);
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}

export function downloadJsonFile(data, name) {
  const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(data))}`;
  const nameStr = `${name}.json` || `DOWNLOAD ${moment().unix()}.json`;

  downloadResource(dataStr, nameStr);
}

export async function downloadBankCsv() {
  try {
    const urlPath = './api/banks/download-bank-csv';

    const response = await axios.get(urlPath);
    if (!response.data) {
      throw new Error();
    }

    const prefix = 'data:text/csv;charset=urf-8,';
    const dataString = `${prefix}${encodeURIComponent(response.data)}`;

    downloadResource(dataString, 'routing-numbers.csv');
  } catch (err) {
    alert('Unable to download CSV file');
  }
}
